import _ from '@lodash';
import { withStyles } from '@material-ui/core';
import Viewer, { defaultLayout, Worker } from '@phuocng/react-pdf-viewer';
import '@phuocng/react-pdf-viewer/cjs/react-pdf-viewer.css';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import MobileDetect from 'mobile-detect';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import React from 'react';
import XAPPButton from '../Button/XAPPButton';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const md = new MobileDetect(window.navigator.userAgent);

const styles = (theme) => ({
    iframePDF: {
        width: '100%',
        height: '100%'
    },
    divMain: {
        width: '100%',
    }
});

const Modelo = {
    pageOrientation: 'landscape',
    content: [
        { text: '', fontSize: 14, bold: true, margin: [0, 20, 0, 8] },
        {
            style: 'tableExample',
            table: {
                body: []
            },
            layout: 'lightHorizontalLines'
        }
    ]
}

class ImprimirPDF extends XAPPComponent {

    state = {
        open: false,
        url: ''
    };

    componentDidMount() {
        this.renderPDF(this.translateTemplate());
    }

    renderToolbar = (toolbarSlot) => {
        return (
            <div
                style={{
                    alignItems: 'center',
                    display: 'flex',
                    width: '100%',
                }}
            >
                <div
                    style={{
                        alignItems: 'center',
                        display: 'flex',
                        flexGrow: 1,
                        flexShrink: 1,
                        justifyContent: 'center',
                    }}
                >
                    <div className={'viewer-toolbar-item'}>
                        {toolbarSlot.zoomOutButton}
                    </div>
                    <div className={'viewer-toolbar-item'}>
                        {toolbarSlot.zoomPopover}
                    </div>
                    <div className={'viewer-toolbar-item'}>
                        {toolbarSlot.zoomInButton}
                    </div>
                    <div className={'viewer-toolbar-item'}>
                        {toolbarSlot.downloadButton}
                    </div>
                    <div className={'viewer-toolbar-item'}>
                        <a
                            href={this.state.url}
                            target="_blank"
                            without
                            rel="noopener noreferrer"
                        >
                            <XAPPButton
                                tooltip={{ "title": "Visualizar tela cheia", "placement": "top" }}
                                type="Icon"
                                className="py-8 px-12"
                                onClick={(ev) => { }}
                                disabled={true}
                                icon={"print"}
                                iconProps="text-black"
                            />
                        </a>
                    </div>
                    <div className={'viewer-toolbar-item'}>
                        {toolbarSlot.fullScreenButton}
                    </div>
                </div>
            </div>
        );
    };

    layout = (isSidebarOpened, container, main, toolbar, sidebar) => {
        return defaultLayout(
            isSidebarOpened,
            container,
            main,
            toolbar(this.renderToolbar),
            sidebar,
        );
    };

    renderPDF = (_AValue) => {
        const pdfDocGenerator = pdfMake.createPdf(JSON.parse(_AValue));
        pdfDocGenerator.getDataUrl((_AData) => {

            const blob = this.base64toBlob(_AData);
            var url = URL.createObjectURL(blob);
            this.setState({ url: url });
        });
    }

    translateTemplate = () => {
        var AStringTemplate = '';
        var AResponse = JSON.parse(JSON.stringify(Modelo));
        var AMatriz = [];
        var ATmp = [];
        this.props.column.forEach(col => {
            if (!_.isUndefined(col.Header) && !_.isNull(col.Header) && typeof col.Header === "string") {
                ATmp.push({ text: col.Header, style: 'tableHeader' });
            }
            else {
                ATmp.push("");
            }
        });
        AMatriz.push(ATmp);

        this.props.data.forEach(item => {
            var ATmp = [];
            this.props.column.forEach(col => {
                if (col.accessor) {
                    ATmp.push(col.accessor.split('.').reduce((o, k) => { return o && o[k]; }, item));
                    //  ATmp.push(item[col.accessor]);
                }
                else {
                    ATmp.push("");
                }
            });
            AMatriz.push(ATmp);
        });
        AResponse.content[0].text = this.props.label;
        AResponse.content[1].table.body = AMatriz;
        AResponse.content[1].table.widths = [];
        this.props.column.map(x => {
            AResponse.content[1].table.widths.push("*");
        });
        return JSON.stringify(AResponse);
    }

    base64toBlob = (data) => {
        const base64WithoutPrefix = data.substr('data:application/pdf;base64,'.length);
        const bytes = atob(base64WithoutPrefix);
        let length = bytes.length;
        let out = new Uint8Array(length);

        while (length--) {
            out[length] = bytes.charCodeAt(length);
        }

        return new Blob([out], { type: 'application/pdf' });
    };

    openDialog = () => {
        this.setState({ open: !this.state.open });
    }

    render() {
        const { data, open, url } = this.state;
        const { classes, conteudo } = this.props;

        return (
            <div className={classes.divMain}>
                {url.length > 0 &&
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.8.335/build/pdf.worker.min.js" target="_blank" without rel="noopener noreferrer">
                        <Viewer
                            fileUrl={url}
                            layout={this.layout}
                        />
                    </Worker>
                }
            </div>
        )
    };
}

export default withStyles(styles, { withTheme: true })(ImprimirPDF);
